export enum VoucherDetailsTab {
  Overview = 'overview',
  Transactions = 'transactions',
}

export const voucherDetailsTabTitles = {
  [VoucherDetailsTab.Overview]: 'Overview',
  [VoucherDetailsTab.Transactions]: 'Transactions',
}

export enum VoucherActionType {
  EditDraft = 'editDraft',
  EditReview = 'editReview',
  ViewInTransactions = 'viewInTransactions',
  SubmitDraft = 'submitDraft',
  SubmitAudit = 'submitAudit',
  SubmitApproval = 'submitApproval',
  SubmitCertification = 'submitCertification',
  Rework = 'rework',
  RevertToDraft = 'revertToDraft',
  Delete = 'delete',
  Sync = 'sync',
  Export = 'export',
}
